/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';

import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';
import { RegularButton, DatePicker, IconButton } from 'pg-ui-library';

import { useTranslation } from 'react-i18next';
import paymentsService from 'src/services/payments.service';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypedSelector';

import { IPayStub } from 'src/interfaces';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import { PayHistoryTable } from 'src/components';
import {
  Container,
  ScreenHeader,
  CardContainer,
  CardHeader,
  LeftHeader,
  RightHeader,
  CardContent,
  DropdownWrapper,
  CardTitle,
  PageTitle,
  RegularText,
} from './styles';

const PayHistory: React.FC = () => {
  const { t } = useTranslation();
  const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  const [hideData, setHideData] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date>(new Date(new Date().getFullYear(), 0, 1));
  const [endDate, setEndDate] = useState<Date>(lastDayOfMonth);
  const { data: configData } = useTypedSelector(state => state.config);
  const { getPayments, patchConfig } = useActions();
  const [dataFiltered, setDataFiltered] = useState<IPayStub[]>([]);

  const loadPaymentData = () => {
    getPayments(startDate.toISOString(), endDate.toISOString());
  };

  useEffect(() => {
    loadPaymentData();
  }, []);

  useEffect(() => {
    loadPaymentData();
  }, [startDate, endDate]);

  useEffect(() => {
    if (configData.config?.hidePaymentData) {
      setHideData(configData.config?.hidePaymentData);
    } else {
      setHideData(false);
    }
    loadPaymentData();
  }, [configData.config?.hidePaymentData]);

  const handleDataView = () => {
    if (configData.config) {
      patchConfig({ id: configData.config.id, hidePaymentData: !hideData });
    } else {
      patchConfig({ hidePaymentData: !hideData });
    }
    setHideData(!hideData);
  };

  const getAllPaystubByPeriod = () => paymentsService.getAllPayStubPdf(startDate.toISOString(), endDate.toISOString());
  const exportPaystubsToExcel = () => {
    exportToXLSX(dataFiltered || [], 'paystatement', 'pay-statements');
  };

  const hasFilteredData = useMemo(() => dataFiltered.length > 0, [dataFiltered]);

  return (
    <Container>
      <ScreenHeader>
        <PageTitle>{t('payHistory.pageTitle')}</PageTitle>
        {hideData ? (
          <IconButton onClick={handleDataView}>
            <IoEyeOutline size="2rem" style={{ margin: 0, width: 15, height: 15 }} />
          </IconButton>
        ) : (
          <IconButton onClick={handleDataView}>
            <IoEyeOffOutline size="2rem" style={{ margin: 0, width: 15, height: 15 }} />
          </IconButton>
        )}
      </ScreenHeader>
      <CardContainer>
        <CardHeader>
          <LeftHeader>
            <CardTitle>{t('payHistory.table.title')}</CardTitle>
            <DropdownWrapper>
              <DatePicker
                label={t('payHistory.table.dropdown.label')}
                id="datePicker"
                name="datePicker"
                dateFormat="MM/dd/yyyy"
                selected={startDate}
                maxDate={endDate}
                onChange={(val: any) => {
                  if (val) setStartDate(val);
                }}
              />
              <RegularText>{t('payHistory.table.dropdown.functionWord')}</RegularText>
              <DatePicker
                label=" "
                id="datePicker"
                name="datePicker"
                dateFormat="MM/dd/yyyy"
                selected={endDate}
                minDate={startDate}
                onChange={(val: any) => {
                  if (val) setEndDate(val);
                }}
              />
            </DropdownWrapper>
          </LeftHeader>
          {/* <RightHeader>
            <RegularButton onClick={exportPaystubsToExcel} disabled>
              {t('payHistory.table.buttons.excel')}
            </RegularButton>

            <a href={getAllPaystubByPeriod()} download target="_blank" rel="noreferrer">
              <RegularButton disabled>{t('payHistory.table.buttons.pdf')}</RegularButton>
            </a>
          </RightHeader> */}
        </CardHeader>
        <CardContent>
          <PayHistoryTable
            onFilter={(data: IPayStub[]) => {
              setDataFiltered(data);
            }}
          />
        </CardContent>
      </CardContainer>
    </Container>
  );
};

export default PayHistory;
